import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import styled from '@emotion/styled';
import { DARK_GRAY } from '../../../styles/constants/color';
import { css } from '@emotion/react';

const Button = styled.button<{ isPrintHide: boolean }>`
  width: auto;
  height: auto;

  ${props =>
    props.isPrintHide &&
    css`
      @media print {
        display: none;
      }
    `}
`;

interface Props {
  size?: number;
  isPrintHide?: boolean;
  onClick: () => void;
}

/**
 *  닫기 버튼 컴포넌트
 * @param {number} size 버튼 사이즈 (default 40)
 * @param {boolean} isPrintHide 프린트시 display none 여부
 * @param {function} onClick 닫기 버튼 클릭 함수
 *  */
function CloseButton({ size = 40, isPrintHide = false, onClick }: Props): JSX.Element {
  return (
    <Button onClick={onClick} isPrintHide={isPrintHide}>
      <IoCloseOutline color={DARK_GRAY} size={size} />
    </Button>
  );
}

export default CloseButton;
